<template>
  <div>
    <event-header :event="$store.state.editor.event" />

    <div class="rounded-md bg-red-50 p-4 mb-10" v-if="hasErrors">
      <div class="flex">
        <div class="flex-shrink-0">
          <font-awesome-icon class="text-red-400" :icon="['fad', 'times-circle']" />
        </div>
        <div class="ml-3">
          <h3 class="text-sm leading-5 font-medium text-red-800">Es sind Fehler aufgetreten.</h3>
          <div class="mt-2 text-sm leading-5 text-red-700">
            <ul class="list-disc pl-5">
              <li v-for="(error, key) in errors" :key="key" class="mt-1">{{error[0]}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div>
      <event-editor :isDraft="isDraft" :errors="errors" :event="event" />
      <div
        v-show="isDirty"
        class="p-4 mt-10 z-10 ml-auto md:w-2/3 rounded-lg shadow-xl border border-gray-200 bg-white flex justify-between items-center bottom-10 sticky"
      >
        <div class="text-gray-800 text-sm">Änderungen werden erst nach dem Speichern veröffentlicht.</div>
        <basic-button
          @click="patch"
          :disabled="loading"
          :loading="loading"
          color="green"
          leading-icon="save"
        >Speichern</basic-button>
      </div>
    </div>
  </div>
</template>

<script>
import EventHeader from "@/components/EventHeader";
import EventEditor from "@/components/editor/EventEditor";

import eventsClient from "@/api/central/events";

import _cloneDeep from "lodash/cloneDeep";
import _isEmpty from "lodash/isEmpty";

export default {
  components: {
    EventHeader,
    EventEditor
  },

  data() {
    return {
      event: _cloneDeep(this.$store.state.editor.event),
      loading: false,
      isDirty: false,
      errors: {}
    };
  },

  watch: {
    event: {
      handler(oldValue, newValue) {
        this.isDirty = true;
      },
      deep: true
    }
  },

  computed: {
    hasErrors() {
      return !_isEmpty(this.errors);
    },
    isDraft() {
      return this.event.status === "draft";
    }
  },

  methods: {
    patch() {
      this.loading = true;
      this.errors = {};

      eventsClient
        .update(this.event.id, this.event)
        .then(async () => {
          await this.$store.dispatch("editor/refresh");

          this.event = _cloneDeep(this.$store.state.editor.event);

          this.$nextTick(() => (this.isDirty = false));

          this.$toasted.global.saved();
        })
        .catch(error => {
          this.errors = error.response.data.errors;

          this.$toasted.global.error();
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>


<style>
trix-editor {
  @apply .border-gray-400 .p-4 .h-64 .overflow-y-auto;
}

.trix-button-row {
  @apply .overflow-x-auto;
}

.trix-button-row .trix-button-group--file-tools {
  @apply .hidden;
}

.trix-button-row .trix-button--icon-code {
  @apply .hidden;
}

trix-editor ul {
  @apply .list-disc;
}

trix-editor ol {
  @apply .list-decimal;
}

trix-editor strong {
  @apply .font-semibold;
}

trix-editor a {
  @apply .text-blue-500;
}

trix-editor a:hover {
  @apply .underline;
}
</style>